import { mixHex, pickInk } from "./color";

export interface SkillLevelVisual {
  background: string;
  previewHex: string;
  textColor: string;
}

const SWATCH_ACCENT_PERCENT_BY_LEVEL = [8, 14, 26, 36, 46, 62, 76] as const;
const BAND_ACCENT_PERCENT_BY_LEVEL = [2, 5, 10, 15, 21, 32, 40] as const;

function accentPercentFor(level: number, scale: readonly number[]): number {
  const index = Math.min(Math.max(Math.round(level), 1), scale.length) - 1;
  return scale[index] ?? 0;
}

export function skillLevelSwatch(level: number, accentColor: string): SkillLevelVisual {
  const accentPercent = accentPercentFor(level, SWATCH_ACCENT_PERCENT_BY_LEVEL);
  const previewHex = mixHex("#ffffff", accentColor, accentPercent / 100);
  return {
    background: `color-mix(in srgb, var(--color-accent) ${accentPercent}%, white)`,
    previewHex,
    textColor: pickInk(previewHex),
  };
}

export function skillLevelBandBackground(level: number): string {
  const accentPercent = accentPercentFor(level, BAND_ACCENT_PERCENT_BY_LEVEL);
  return `color-mix(in srgb, var(--color-accent) ${accentPercent}%, var(--color-surface))`;
}
